import { withApollo } from '@apollo/client/react/hoc'
import compose from 'lodash/flowRight'
import { connect } from 'react-redux'

import { renderSuccessNotification } from 'store/notificationHandler/actions'
import { getSelectedOrdersIds } from 'store/orderList/selectors'
import {
  getAppliedFilters,
  getSearchFilter,
} from 'store/orderListFilters/selectors'

import UpdateOrderPricingModal from './UpdateOrderPricingModal.component'
import {
  withUpdateOrderPricingByFiltersMutation,
  withUpdateOrderPricingByIdsMutation,
} from './UpdateOrderPricingModal.mutations'

const mapStateToProps = (state) => ({
  selectedOrderIds: getSelectedOrdersIds(state),
  appliedFilters: getAppliedFilters(state),
  searchFilter: getSearchFilter(state),
})

const mapDispatchToProps = {
  renderSuccessNotification,
}

const withRedux = connect(mapStateToProps, mapDispatchToProps)

export default compose(
  withRedux,
  withApollo,
  withUpdateOrderPricingByIdsMutation,
  withUpdateOrderPricingByFiltersMutation,
)(UpdateOrderPricingModal)
